import React, { useEffect, useState } from "react";
import { NAVBAR_LIST } from "./Helper";
import { PhoneIcon } from "./Icons";
import PageLogo from "../../assets/img/tripnest-logo.webp";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activePath, setActivePath] = useState(window.location.pathname);

  const handler = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleOverflow = () => {
      if (isOpen && window.innerWidth < 1025) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    };

    const handlePathChange = () => {
      setActivePath(window.location.pathname);
    };

    handleOverflow();
    window.addEventListener("resize", handleOverflow);
    window.addEventListener("popstate", handlePathChange);

    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("resize", handleOverflow);
      window.removeEventListener("popstate", handlePathChange);
    };
  }, [isOpen]);

  return (
    <>
      <div className="navbar-shadow">
        <nav className="flex items-center justify-between max-w-[1200px] mx-auto px-5 py-[29.2px] max-md:py-6">
          <a href="/">
            <img
              src={PageLogo}
              alt="logo"
              className="w-[128px] h-[41.94px] pointer-events-none"
            />
          </a>
          <div
            className={`flex items-center justify-center max-lg:flex-col max-lg:justify-center max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:w-full max-lg:h-screen max-lg:bg-white max-lg:z-[90] transition-transform duration-300 ${
              isOpen ? "max-lg:-translate-y-0" : "max-lg:-translate-y-full"
            }`}
          >
            <ul className="flex items-center justify-center gap-[26px] max-lg:flex-col max-lg:gap-6">
              {NAVBAR_LIST.map((obj, i) => (
                <li key={i}>
                  <a
                    href={obj.link}
                    onClick={() => {
                      handler();
                      setActivePath(obj.link);
                    }}
                    className={`leading-[100%] text-base font-normal ff-sans transition-all duration-300 ${
                      activePath === obj.link
                        ? "text-[#ff5858] font-semibold"
                        : "text-[#363636] hover:text-[#ff5858]"
                    }`}
                  >
                    {obj.title}
                  </a>
                </li>
              ))}
            </ul>
            <div className="lg:hidden pt-8">
              <a
                href="tel:+91-1234567890"
                className="flex items-center justify-center gap-1 whitespace-nowrap"
              >
                <PhoneIcon />
                <p className="ff-sans text-base font-semibold leading-[150%] text-[#ff5858]">
                  +91-1234567890
                </p>
              </a>
            </div>
          </div>
          <div className="max-lg:hidden">
            <a
              href="tel:+91-1234567890"
              className="flex items-center justify-center gap-1 whitespace-nowrap"
            >
              <PhoneIcon />
              <p className="ff-sans text-base font-semibold leading-[150%] text-[#ff5858]">
                +91-1234567890
              </p>
            </a>
          </div>
          <button
            onClick={handler}
            className="flex flex-col justify-center items-center z-[100] gap-1 lg:hidden relative size-6"
          >
            <span
              className={`h-1 w-full bg-black rounded transition-all duration-300 ${
                isOpen ? "rotate-45 translate-y-[8px]" : ""
              }`}
            ></span>
            <span
              className={`h-1 w-full bg-black rounded transition-all duration-300 ${
                isOpen ? "opacity-0" : ""
              }`}
            ></span>
            <span
              className={`h-1 w-full bg-black rounded transition-all duration-300 ${
                isOpen ? "-rotate-45 -translate-y-[8px]" : ""
              }`}
            ></span>
          </button>
        </nav>
      </div>
    </>
  );
};

export default Header;
